import React, { useState, useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import VenuemonkBenefits from './VenuemonkBenefits';
import { ThreeBounce } from 'better-react-spinkit';
import isEmpty from 'lodash/isEmpty';
import styles from '../../../styles/enquiryform.module.css';
import {
    getEnquiryFormParams,
    getIsShowOtpSegmentForFFTVM,
} from '../../../redux/selectors/LeadFormSelectors';

import {
    planEventForFFTVM,
    sendOTP,
    showOtpSegmentForFFTVM,
} from '../../../redux/actions/LeadFormActions';
import { verifyOTPCode } from '../../../redux/actions/EventVerificationActions';
import { getAuthenticatedState } from '../../../redux/selectors/AppSelectors';
import { getSelectedEvent, getSelectedEventIdFromEvent } from '../../../redux/selectors/EventSelectors';

import { getIsOtpVerified } from '../../../redux/reducers/AppReducer';

import { getIsSubmitting } from '../../../redux/selectors/LeadFormSelectors';
import WhatsappToggle from '../../leads/LeadForm/SliderForm/components/WhatsappToggle';
import { MODELS, haveuscallyouform_termsandconditiontext } from '../../../constants/constants';
import Timer from './Timer';
import { getVerifyingOTPState } from '../../../redux/selectors/EventVerificationSelectors';
import {
    getDevice,
    getEnquiryFormBtnText,
    getEnquiryFormSource,
    getEnquiryFormTitle,
    getHaveUsCallYouFormLeadSource,
} from '../../../util/leadFormUtility';
import { newGtmCustomEvent } from '../../utility/gtmTrigger';
import { loadVmLeadTrackContent } from '../../../util/vmCookieHandler';
import { setEnquiryFormStats, setLeadFormStats } from '../../../util/vmSearch';
import { ENQUIRY_FORM_TITLE } from '../../../constants/enquiryFormConst';
import { createSuperEvent } from '../../utility/trackingWrapper';
import { getSelectedVenues } from '../../../redux/selectors/VenueSelectors';
import { gtmAlert } from '../../../util/gtmTrigger';
import InputField from '../../../components/custom-components/InputField';
import { validateLeadForm } from '../../utils/leadForm';
const TIMER_START = 60;
const CONTACT_DETAILS = 'contact-details';
const OTP = 'otp';

const EnquiryForm = (props) => {
    const isShowOtpSegmentForFFTVM = useSelector((state) => getIsShowOtpSegmentForFFTVM(state));
    const isAuthenticated = useSelector((state) => getAuthenticatedState(state));
    const selectedVenue = useSelector((state) => getSelectedVenues(state));
    const eventId = useSelector((state) => getSelectedEventIdFromEvent(state));
    const plannedEvent = useSelector((state) => getSelectedEvent(state));
    const isSubmitting = useSelector((state) => getIsSubmitting(state));
    const isVerifyingOtp = useSelector((state) => getVerifyingOTPState(state));
    const isOtpVerified = useSelector((state) => getIsOtpVerified(state));
    const formPrams = useSelector(getEnquiryFormParams);
    const [checked, setIsChecked] = useState(false);
    const [countryCode, setCountryCode] = useState('+91');
    const [fullName, setFullName] = useState('');
    const [mobileNumber, setMobileNumber] = useState('');
    const [otp, setOtp] = useState('');
    const [isOtpInvalid, setIsOtpInvalid] = useState(false);
    const [isPhoneNumberInvalid, setIsPhoneNumberInvalid] = useState(false);
    const [isNameInvalid, setIsNameInvalid] = useState(false);
    const [isOtpAuthenticated, setIsOtpAuthenticated] = useState(false);
    const [phoneNumberInvalidMessage, setPhoneNumberInvalidMessage] = useState('');
    const [nameInvalidMessage, setNameInvalidMessage] = useState('');
    const [segment, setSegment] = useState(CONTACT_DETAILS);
    const [counter, setCounter] = useState(TIMER_START);
    const [isWhatsappToggled, setIsWhatsappToggled] = useState(true);
    const [timer, setTimer] = useState(0);
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(0);
    const [isShowEditButton, setIsShowEditButton] = useState(false);
    const [isResendOtpVisible, setIsResendOtpVisible] = useState(false);

    const [timeLeft, setTimeLeft] = useState(60);
    const dispatch = useDispatch();

    const nameRef = useRef(null);

    const otpInputError = {
        border: '1px solid #B00020',
    };

    const {
        enquiryFormVendorType,
        enquiryFormType,
        enquiryFormBtnSource,
        enquiryFormPageType,
        enquiryFormLeadFillingPage,
        enquiryFormleadType,
    } = formPrams;

    const inOtpStep = segment === OTP || !!isShowOtpSegmentForFFTVM;

    useEffect(() => {
        if (!isEmpty(props.event) && props.event.event) {
            setFullName(props.event.event.contact_name);
            setMobileNumber(props.event.event.contact_phone);
        }
    }, [props.event]);

    useEffect(() => {
        if (!inOtpStep || isEmpty(plannedEvent)) return;
        const name = plannedEvent.contact_name;
        const phone = plannedEvent.contact_phone;
        if (name) {
            setFullName((prev) => (prev && String(prev).trim() ? prev : name));
        }
        if (phone != null && phone !== '') {
            setMobileNumber((prev) => (prev && String(prev).trim() ? prev : String(phone)));
        }
    }, [inOtpStep, plannedEvent]);

    useEffect(() => {
        if (isOtpVerified) {
            setIsOtpAuthenticated(true);
        } else {
            setIsOtpAuthenticated(false);
        }
    }, [isOtpVerified]);

    const onChecked = () => {
        setIsChecked(!checked);
    };

    const onUnChecked = () => {
        setIsChecked(!checked);
    };

    const getVendorTypeNeeded = (key) => {
        if (key) {
            return {
                [MODELS[key].event_key]: true,
            };
        } else return key;
    };

    useEffect(() => {
        if (segment === OTP) {
            setSegment(OTP);
            setTimer(counter > 0 && setInterval(() => setCounter(counter - 1), 1000));
            return () => clearInterval(timer);
        }
    }, [segment, counter]);

    const clearTimer = () => clearInterval(timer);

    useEffect(() => {
        setIsOtpInvalid(props.invalidOtp);
        setCounter(TIMER_START);
    }, [props.invalidOtp]);

    useEffect(() => {
        if (inOtpStep) {
            // Name/phone can be empty after remount while Redux still shows OTP — verify only needs OTP
            setIsSubmitButtonDisabled(otp.trim().length < 4);
        } else if (fullName == '' || mobileNumber == '' || mobileNumber.length < 10) {
            setIsSubmitButtonDisabled(true);
        } else {
            setIsSubmitButtonDisabled(false);
        }
    }, [fullName, mobileNumber, inOtpStep, otp]);

    const handleOnChange = (key, value) => {
        if (key === 'fullName') {
            setFullName(value);
            setIsNameInvalid(false);
        } else if (key === 'mobileNumber') {
            setPhoneNumberInvalidMessage('');
            setIsPhoneNumberInvalid(false);
            setMobileNumber(value);
        }
    };

    const hanldeOtpInput = (e) => {
        let value = e.target.value;
        setOtp(value);
    };

    const formatCounter = (timer) => {
        const minutes = Math.floor(timer / 60);
        const seconds = timer - minutes * 60;
        return `${minutes > 10 ? minutes : '0' + minutes}:${
            seconds > 10 ? seconds : '0' + seconds
        }`;
    };

    const planTheEvent = () => {
        const name = fullName.trim();
        const phone = mobileNumber.trim();
        // processGtmDatalayer({
        //   gtmPageView1:processPageViewUrlForNewOldLeadForm(EVEN_TRIGGER_CODE,LEADFORM_GOAL_TRACKING_STAGE.details,this.props.leadTriggerFormCode),
        // }, null);
        const { selectedCity } = props;
        const validate = validateLeadForm({ name, phone });
        if (!name) {
            setIsNameInvalid(true);
            setNameInvalidMessage('Invalid Name');
            return;
        }
        if (!validate.validated) {
            setIsPhoneNumberInvalid(true);
            setPhoneNumberInvalidMessage(validate.text);
            return;
        } else {
            setIsPhoneNumberInvalid(false);
            setPhoneNumberInvalidMessage('');
            setIsNameInvalid(false);
            const eventInput = {};
            eventInput.contact_name = name;
            eventInput.contact_phone = phone;
            eventInput.country_code = !!countryCode ? countryCode : '+91';

            const planEventInput = {
                country_code: '+91',
                contact_name: name,
                contact_phone: phone,
                phone: phone,
                city: selectedCity === undefined || selectedCity === '' ? 'gurgaon' : selectedCity,
                lead_source: getEnquiryFormSource(enquiryFormVendorType, enquiryFormType),
                ...getVendorTypeNeeded(enquiryFormVendorType),
                is_opted_in: isWhatsappToggled,
                useWhatsAppToContactMe: isWhatsappToggled,
                leadFormStats: {
                    ...loadVmLeadTrackContent(),
                    btn_source: `${enquiryFormBtnSource}-${getDevice()}`,
                    ...setEnquiryFormStats({}),
                    app_source: getEnquiryFormSource(enquiryFormVendorType, enquiryFormType),
                    leadFillPage: window.location.pathname,
                    lead_type: enquiryFormleadType ?? 'venue',
                },
            };

            if (!isEmpty(selectedVenue)) {
                planEventInput.city = selectedVenue.city_slug;
                planEventInput.location = selectedVenue.sub_area;
                planEventInput.region = selectedVenue.region_slug;
                planEventInput.venuetypes = selectedVenue.propertyType[0];
                planEventInput.packagetype = 1;
                planEventInput.budget_start = selectedVenue.veg_show;
                planEventInput.budget_end = selectedVenue.veg_show;
            }

            let stats = {};
            let vmLeadInfo = loadVmLeadTrackContent();
            if (vmLeadInfo) {
                stats = vmLeadInfo;
            }
            const newStats = setLeadFormStats(stats);

            planEventInput.leadFormStats = { ...planEventInput.leadFormStats, ...newStats };

            gtmAlert('finalEventSubmitClick');
            gtmAlert('lead_final_event_submit');
            gtmAlert('finalEventSubmitClickNewForm');

            dispatch(planEventForFFTVM(planEventInput));
            setSegment(OTP);
            dispatch(showOtpSegmentForFFTVM(true));
            setIsShowEditButton(true);
        }
    };

    const handleSubmitButton = () => {
        if (!inOtpStep) {
            createSuperEvent({
                event_name: `${
                    ENQUIRY_FORM_TITLE[enquiryFormType].triggerCode
                }-${enquiryFormPageType.toLowerCase()}-lead-form-final-submit`,
                btn_label: 'Submit',
                action_name: 'submit-details',
                feature_name: 'enquiry-form',
                segment_name: 'details-slide',
            });
            planTheEvent();
        } else {
            dispatch(verifyOTPCode(eventId, otp, 'vendor-have-us-callyou'));
        }
    };

    const getWhatsappToggleStatus = (val) => {
        setIsWhatsappToggled(val);
    };

    const handleEditClick = () => {
        setOtp('');
        if (inOtpStep) {
            dispatch(showOtpSegmentForFFTVM(false));
            setSegment(CONTACT_DETAILS);
            setIsShowEditButton(false);
            nameRef.current.focus();
        }
    };

    const handleResendOtp = (id) => {
        setOtp('');
        setTimeLeft(59);
        setIsResendOtpVisible(false);
        dispatch(sendOTP(id, { phone: mobileNumber }));
    };
    return (
        <div className={styles['hucyf-container']}>
            <h3 className={styles['have-us-call-you-text']}>
                {getEnquiryFormTitle(enquiryFormType)}
            </h3>
            <div className={styles['vm-benefits-container']}>
                <VenuemonkBenefits
                    title={'Verified Listings'}
                    image={'https://cdn.venuemonk.com/verified_listing_tick.png'}
                />
                <VenuemonkBenefits
                    title={'Hassle Free'}
                    image={'https://cdn.venuemonk.com/hassle_free_thumb.png'}
                />
                <VenuemonkBenefits
                    title={'Best Price Guarantee'}
                    image={'https://cdn.venuemonk.com/best_price_ruppee.png'}
                />
            </div>
            <div className={styles['inputs-container']}>
                <div className={styles['edit-details']}>
                    <span>Enter your details: </span>
                    {isShowEditButton && (
                        <span className={styles['edit-button']} onClick={handleEditClick}>
                            Edit
                        </span>
                    )}
                </div>
                <InputField
                    id={'full_name'}
                    placeholder={'Enter your full name'}
                    value={fullName}
                    disabled={inOtpStep}
                    inputMode="text"
                    autoComplete="name"
                    onChange={(e) => handleOnChange('fullName', e)}
                    label="Full Name"
                    showErrorMessage={isNameInvalid}
                    errorMessage={nameInvalidMessage}
                    inputRef={nameRef}
                />
                <InputField
                    id={'mobile_number'}
                    placeholder={'Enter Mobile No'}
                    label="Mobile Number"
                    value={mobileNumber}
                    type={'number'}
                    inputMode="numeric"
                    autoComplete="tel-national"
                    maxlength={'10'}
                    disabled={inOtpStep}
                    onChange={(e) => handleOnChange('mobileNumber', e)}
                    showErrorMessage={isPhoneNumberInvalid}
                    errorMessage={'Invalid Number.'}
                />
                {!inOtpStep && (
                    <div style={{ width: '100%' }}>
                        <WhatsappToggle getWhatsappToggleStatus={getWhatsappToggleStatus} />
                    </div>
                )}
            </div>
            
            {inOtpStep && (
                <div className={styles['otp-container']}>
                    <div className={styles['otp-status']}>
                        <span>Please enter OTP to verify</span>
                        {timeLeft !== 0 && (
                            <Timer
                                time={60}
                                timeProgress={(val) => setTimeLeft(val)}
                                timeFinish={() => {
                                    setIsResendOtpVisible(true);
                                }}
                            />
                        )}
                        {timeLeft !== 0 && (
                            <span className={styles['timer-value']}>
                                {`00:${timeLeft.toString().padStart(2, '0')}`} sec
                            </span>
                        )}
                        {isResendOtpVisible && (
                            <span
                                className={styles['resend-otp-text']}
                                onClick={() => handleResendOtp(eventId)}
                            >
                                Resend OTP
                            </span>
                        )}
                    </div>
                    <input
                        type="name"
                        maxLength={'4'}
                        className={styles['otp-input']}
                        value={otp}
                        onChange={(e) => hanldeOtpInput(e)}
                    />
                </div>
            )}
            <div className={styles['hucyf-bottom-container']}>
                <span>{haveuscallyouform_termsandconditiontext}</span>
                <button
                    type="button"
                    className={`btn ${styles.submitPink}`}
                    onClick={() => handleSubmitButton()}
                    style={{ height: '44px', width: '100%', borderRadius: '4px' }}
                    disabled={isSubmitButtonDisabled || isSubmitting || isVerifyingOtp}
                >
                    {isSubmitting || isVerifyingOtp ? (
                        <div className="text-center">
                            <ThreeBounce color={'#ffffff'} size={14} />
                        </div>
                    ) : (
                        <span className={styles['submit-span']}>
                            {inOtpStep ? 'Verify' : getEnquiryFormBtnText(enquiryFormType)}
                        </span>
                    )}
                </button>
            </div>
        </div>
    );
};

export default EnquiryForm;
